import { OPEN_CTA_PROMPT, CLOSE_CTA_PROMPT } from './ctaPromptActions'
import { Map } from 'immutable'

const INITIAL_STATE = Map({
    isCTAPromptOpen: false,
    isModalCTAPrompt: false,
    ctaPromptType: undefined,
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case OPEN_CTA_PROMPT:
            return state.withMutations(mState => {
                return mState
                    .set('isCTAPromptOpen', true)
                    .set('isModalCTAPrompt', action.isModalCTAPrompt)
                    .set('ctaPromptType', action.promptType)
            })
        case CLOSE_CTA_PROMPT:
            if (action.isModal) {
                return state.set('isCTAPromptOpen', false)
            } else return state
        default:
            return state
    }
}
